import { render } from "./SidebarMobile.vue?vue&type=template&id=2349663c&scoped=true"
import script from "./SidebarMobile.vue?vue&type=script&lang=js"
export * from "./SidebarMobile.vue?vue&type=script&lang=js"

import "./SidebarMobile.vue?vue&type=style&index=0&id=2349663c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2349663c"]])

export default __exports__